import {
  eligibilityOptions,
  businessFunctionOptions,
  geographicEligibilityOptions,
  optionLabel,
} from "./criteriaOptions"

// Opportunity attributes added for the filters. They are rendered through
// `buildCriteriaParams` instead of as-is.
export const CRITERIA_KEYS = [
  "eligibility",
  "business_functions",
  "geographic_eligibility",
  "value_min",
  "value_max",
  "status",
  "source",
]

const labels = (options, ids = []) =>
  ids.map((id) => optionLabel(options, id) || id).join(", ")

const money = (value) => `$${Number(value).toLocaleString("en-US")}`

const formatValueRange = (min, max) => {
  const hasMin = min !== null && min !== undefined
  const hasMax = max !== null && max !== undefined
  if (hasMin && hasMax)
    return min === max ? money(min) : `${money(min)} - ${money(max)}`
  if (hasMin) return `From ${money(min)}`
  if (hasMax) return `Up to ${money(max)}`
  return ""
}

/** [title, value] pairs for the fields that are set, in display order. */
export const buildCriteriaParams = (data) =>
  [
    ["eligibility", labels(eligibilityOptions, data.eligibility)],
    ["opportunity_value", formatValueRange(data.value_min, data.value_max)],
    [
      "business_function",
      labels(businessFunctionOptions, data.business_functions),
    ],
    [
      "geographic_eligibility",
      labels(geographicEligibilityOptions, data.geographic_eligibility),
    ],
    // Every opportunity is open unless closed, so only "Closed" is worth showing.
    ["opportunity_status", data.status === "close" ? "Closed" : ""],
    ["source", data.source === "b2t_admin" ? "B2T Platform Administrator" : ""],
  ].filter(([, value]) => Boolean(value))
